import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import type { Cluster } from '../../types/teaser';
interface ClusterLightboxProps {
  cluster: Cluster;
  onClose: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function ClusterLightbox({
  cluster,
  onClose
}: ClusterLightboxProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.18,
    ease: EASE
  }} className="fixed inset-0 z-50 flex items-center justify-center bg-navy/50 px-8 py-10" role="dialog" aria-modal="true" aria-label={`${cluster.name} enlarged`} onClick={onClose} data-id="element-50" data-mp="1gcrfb1ep7k5w">
      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.98
    }} transition={{
      duration: 0.22,
      ease: EASE
    }} onClick={e => e.stopPropagation()} className="w-full max-w-3xl overflow-hidden rounded-2xl bg-paper shadow-soft" data-id="element-51" data-mp="wpjxsuq9dynl">
        <div className="flex items-center justify-between border-b border-line px-5 py-3" data-id="element-52" data-mp="3dmzcq3q6ju1e">
          <p className="text-[10px] uppercase tracking-micro text-mut" data-id="element-53" data-mp="38ph3sdc5xete">{cluster.name}</p>
          <button type="button" onClick={onClose} aria-label="Close enlarged scan" className="flex h-8 w-8 items-center justify-center rounded-full border border-line text-mut transition-colors duration-150 hover:border-mut hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-54" data-mp="33o042l5ezyee">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="2kyjznmqlzlsp" />
          </button>
        </div>
        <img src={cluster.image} alt={`AI-assisted OCT segmentation example — ${cluster.name}`} className="block max-h-[70vh] w-full bg-[#0A0F14] object-contain" data-id="element-56" data-mp="2g0ikhcwb06mi" />
      </motion.div>
    </motion.div>;
}